// extracted by mini-css-extract-plugin
module.exports = {"title":"SurveyQuestionsEditor_title__1EcFi","questionType":"SurveyQuestionsEditor_questionType__2GT3r"};